import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchPhotosRequest,
  fetchPhotosSuccess,
  fetchPhotosFailure,
} from "./images.slice.js";
import { API_URL } from "../../../utils/enum.js";

// API function
function* fetchPhotosApi(action) {
  try {
    const token = localStorage.getItem("token");
    const response = yield call(fetch, `${API_URL}/images/${action.payload}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = yield call([response, response.json]);
    yield put(fetchPhotosSuccess(data?.images || []));
  } catch (err) {
    yield put(fetchPhotosFailure(err.message));
  }
}

// Watcher saga
export function* photoSaga() {
  yield takeLatest(fetchPhotosRequest.type, fetchPhotosApi);
}
